import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUserList } from '../../../../../helpers/user-helper';

export const AccountUsersTabContent = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    const [isLoading, setIsLoading] = React.useState(true);
    const [error, setError] = React.useState('');
    const [summary, setSummary] = React.useState({
        total: 0,
        active: 0,
        inactive: 0,
    });

    const loadSummary = React.useCallback(async () => {
        if (!token) {
            setError('No se pudo validar la sesión.');
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError('');

        const [totalResp, activeResp, inactiveResp] = await Promise.all([
            getUserList(token, { includeDeleted: true, limit: 1, offset: 0 }),
            getUserList(token, { status: 'ACTIVE', limit: 1, offset: 0 }),
            getUserList(token, { status: 'INACTIVE', limit: 1, offset: 0 }),
        ]);

        if (!totalResp?.success || !activeResp?.success || !inactiveResp?.success) {
            setError(totalResp?.message || activeResp?.message || inactiveResp?.message || 'No se pudo obtener el resumen de usuarios.');
            setIsLoading(false);
            return;
        }

        setSummary({
            total: Number(totalResp?.total || 0),
            active: Number(activeResp?.total || 0),
            inactive: Number(inactiveResp?.total || 0),
        });

        setIsLoading(false);
    }, [token]);

    React.useEffect(() => {
        loadSummary();
    }, [loadSummary]);

    return (
        <div>
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <h5 className="fw-bold mb-0">Resumen de usuarios del tenant</h5>
                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate('/settings/users')}
                >
                    Ir a gestión de usuarios
                </button>
            </div>

            {error && (
                <div className="alert alert-danger py-2" role="alert">{error}</div>
            )}

            <div className="row g-3">
                <div className="col-md-4">
                    <div className="border border-dashed border-gray-5 rounded-2 p-3 h-100">
                        <div className="text-muted fs-12 mb-1">Total usuarios</div>
                        <div className="fs-4 fw-bold">{isLoading ? '...' : summary.total}</div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="border border-dashed border-gray-5 rounded-2 p-3 h-100">
                        <div className="text-muted fs-12 mb-1">Usuarios activos</div>
                        <div className="fs-4 fw-bold text-success">{isLoading ? '...' : summary.active}</div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="border border-dashed border-gray-5 rounded-2 p-3 h-100">
                        <div className="text-muted fs-12 mb-1">Usuarios inactivos</div>
                        <div className="fs-4 fw-bold text-danger">{isLoading ? '...' : summary.inactive}</div>
                    </div>
                </div>
            </div>

            <div className="alert alert-info py-2 mt-3" role="alert">
                La administración completa de usuarios (crear, editar y activar/desactivar) se realiza en la sección dedicada de Settings &gt; Usuarios.
            </div>
        </div>
    );
};
